import { useCallback } from "react";
import { authApi } from "~/api";
import { useBrandsQuery } from "~/apis/use-brands-query";
import { useCustomersQuery } from "~/apis/use-customers-query";

export const usePermissionData = () => {
  const {
    data: userData,
    isLoading: isUsersLoading,
    isError: isUsersError,
  } = authApi.useQuery("get", "/api/User", undefined, {
    meta: { errorTitle: "Failed to load user data" },
  });
  const { data: brandData, isLoading: isBrandsLoading, isError: isBrandsError } = useBrandsQuery();
  const {
    data: customerData,
    isLoading: isCustomersLoading,
    isError: isCustomersError,
  } = useCustomersQuery();

  const getCustomerIdForBrand = useCallback(
    (brandId: number): number | undefined => {
      return brandData?.find((b) => b.id === brandId)?.customerId;
    },
    [brandData]
  );

  return {
    isLoading: isUsersLoading || isBrandsLoading || isCustomersLoading,
    isError: isUsersError || isBrandsError || isCustomersError,
    userData,
    brandData,
    customerData,
    getCustomerIdForBrand,
  };
};
